module.exports = "<div ncy-breadcrumb></div> <h1 translate ng-if=!vm.isBlackFriday>Discounts</h1> <h1 translate ng-if=vm.isBlackFriday>Black Friday</h1> <product-overview custom-category=vm.customCategory context=discount-overview on-filter-change=vm.onFilterChange() model=vm.productOverviewModel parent-state=vm.parentState></product-overview>";


//////////////////
// WEBPACK FOOTER
// ./features/discount/discounts.html
// module id = 591
// module chunks = 0